// work data

export const Work = [
    {
        id:1,
        name:"Green Hub",
        description:"Developed GreenHub, an online marketplace connecting farmers, shops, and companies.Users have separate dashboards to manage products, orders, and chats.Real-time messaging, posts, and notifications are supported.Integrated Razorpay for secure, instant payments.Users can negotiate deals, track prices, and complete orders through chat",
        tags:["react","django","mysql"],
        
        demo:"https://app.arcade.software/share/BrT5yG35zCezjG492lmn",
        github:"https://github.com/mukilanmoorthy/Greenhub.git"
    },
    {
        id:2,
        name:"Comparmate",
        description:"Built CompartMate, a ticket booking app that allows users to book 5–6 seats at a time, including group bookings under a single name.The system ensures seat availability and assigns one ticket ID for multiple passengers",
        tags:["react","tailwind css"],
        
        demo:"https://compart-mate-f93u.vercel.app/",
        github:"https://github.com/mukilanmoorthy/CompartMate.git"
        
    },
    {
        id:3,
        name:"Tamilnadu Nursing Admission",
        description:"Created an Admission Form using React.js and integrated EmailJS to send form data directly to admin email",
        tags:["react","tailwind css","freelance"],
        
        demo:"https://tamilnadunursingadmission.com/",
        github:""
       
    },
    {
        id:4,
        name:"Netflix  Clone",
        description:"A clone of Netflix built using HTML, CSS, and JavaScript. Features a stylish homepage UI, responsive movie grid layout, and interactive hover animations to simulate a real Netflix-like browsing experience..",
        tags:["js","html","css"],
        
        demo:"https://lnkd.in/gxnpmkvK",
        github:"https://github.com/mukilanmoorthy/Netflix-Clone.git"
    },
   
    {
        id:5,
        name:"Nool nidhi",
        description:"Developed Nool Nidhi, a library management system to search, issue, and manage books efficiently.Integrated Google Books API for book search and implemented full CRUD operations for users and books.Users can book, return, and track books through a clean and user-friendly interface.",
        tags:["html","react-js","css"],
        
        demo:"",
        github:"https://github.com/mukilanmoorthy/Netflix-Clone.git"
        
    },
    
  
] 